import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import Activity from "@mapmycustomers/shared/types/entity/Activity";

import ActivityTypeSelector from "@app/component/input/ActivityTypeSelector";
import useView from "@app/component/view/utils/useView";
import { getActiveActivityTypes } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";
import { isSimpleCondition } from "@app/util/viewModel/assert";

interface Props {
  activityTypes: ActivityType[];
}

const QuickActivityTypeFilter: React.FC<Props> = ({ activityTypes }) => {
  const {
    updateFilterModel,
    viewState: { filter },
  } = useView<Activity>();

  const handleChange = useCallback(
    (activityTypes: ActivityType[]) => {
      updateFilterModel({
        activityType: activityTypes.length
          ? {
              operator: FilterOperator.IN_ANY,
              value: activityTypes.map(({ id }) => id),
            }
          : undefined,
      });
    },
    [updateFilterModel]
  );

  const selectedActivityTypes = useMemo(() => {
    const selectedActivityTypeIds = new Set(
      filter.activityType &&
      isSimpleCondition(filter.activityType) &&
      filter.activityType.operator === FilterOperator.IN_ANY
        ? (filter.activityType.value as Array<ActivityType["id"]>)
        : []
    );
    return activityTypes.filter(({ id }) => selectedActivityTypeIds.has(id));
  }, [activityTypes, filter]);

  return (
    <ActivityTypeSelector
      activityTypes={activityTypes}
      emptyValueMeansAll
      onChange={handleChange}
      value={selectedActivityTypes}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActiveActivityTypes(state),
});

export default connect(mapStateToProps)(QuickActivityTypeFilter);
